import { icons } from 'src/assets/iconDef/icon.def';

export const accountManagementMenuDef = [
    {
        name: 'menu.account_management',
        icon: icons.application.user,
        data: {
            nav_url: "account_m"
        },



        children: [
            {
                name: 'menu.branding',
                resource: 'branding',
                icon: icons.list.horizontalList,
                url: 'branding',
                auto_crud: true,
                breadcrumb: 'Branding'
            },
            {
                name: 'menu.splash_screen_branding',
                resource: 'splash_screen_branding',
                icon: icons.list.horizontalList,
                url: 'splash_screen_branding',
                auto_crud: true,
                breadcrumb: 'Branding'
            },
            {
                name: 'menu.manage_account',
                resource: 'account',
                icon: icons.list.horizontalList,
                url: 'account',
                auto_crud: true,
                breadcrumb: 'Accounts'
            },
            {
                name: 'menu.manage_system_admins',
                resource: 'manage_system_users',
                icon: icons.list.horizontalList,
                url: 'manage_system_users',
                auto_crud: true,
                breadcrumb: 'Management System Admins'
            },

            {
                name: 'menu.manage_account_admins',
                resource: 'manage_account_admins',
                icon: icons.list.horizontalList,
                url: 'manage_account_admins',
                auto_crud: true,
                breadcrumb: 'Manage Account Admins'
            },

            {
                name: 'menu.manage_facility_admins',
                resource: 'manage_facility_admins',
                icon: icons.list.horizontalList,
                url: 'manage_facility_admins',
                auto_crud: true,
                breadcrumb: 'Manage Facility Admins'
            },

            {
                name: 'menu.manage_users',
                resource: 'manage_users',
                icon: icons.list.horizontalList,
                url: 'manage_users',
                auto_crud: true,
                breadcrumb: 'Manage Users'
            },
            {
                name: 'menu.manage_organization',
                resource: 'userOrganization_mapping',
                icon: icons.list.horizontalList,
                url: 'userOrganization_mapping',
                showMenu: false,
                auto_crud: true,
                breadcrumb: 'Organization'
            },
            {
                name: 'menu.userLocation_mapping_view',
                resource: 'userLocation_mapping_view',
                icon: icons.list.horizontalList,
                url: 'userLocation_mapping_view',
                showMenu: false,
                auto_crud: true,
                breadcrumb: 'User Location Mapping'
            },
            {
                name: 'menu.manage_location',
                resource: 'userLocation_mapping',
                icon: icons.list.horizontalList,
                url: 'userLocation_mapping',
                showMenu: false,
                auto_crud: true,
                breadcrumb: 'Organization'
            },
            {
                name: 'menu.role',
                resource: 'import_roles_and_menu',
                icon: icons.list.horizontalList,
                url: 'import_roles_and_menu',
                auto_crud: true,
                breadcrumb: 'Role Master',
                showMenu: false
            },
            {
                name: "menu.user_type_wise_url_mapping",
                resource: "user_type_wise_url_mapping",
                icon: icons.list.horizontalList,
                url: "user_type_wise_url_mapping",
                auto_crud: true,
                breadcrumb: "User Type Wise URL Mapping"
            },
            {
                name: 'menu.inter_account_master',
                resource: 'inter_account_master',
                icon: 'fa fa-file-text-o',
                url: 'inter_account_master',
                auto_crud: true,
                breadcrumb: 'Inter Account Master'
            }
        ]
    },
    {
        name: 'menu.rbac_master',
        icon: icons.application.role,
        data: {
            nav_url: "role_m"
        },
        children: [
            {
                name: 'menu.role_rbac',
                resource: 'role_rbac',
                icon: icons.list.horizontalList,
                url: 'role_rbac',
                auto_crud: true
            },
            {
                name: 'menu.role_groups',
                resource: 'role_app_master',
                icon: icons.list.horizontalList,
                url: 'role_app_master',
                auto_crud: true,
                breadcrumb: 'Role Application Mapping Master'
            },
            {
                name: 'menu.manage_resource',
                resource: 'application_resource_master',
                icon: icons.list.horizontalList,
                url: 'application_resource_master',
                auto_crud: true,
                breadcrumb: 'Application Resource'
            },
            {
                name: 'menu.role',
                resource: 'role_master',
                icon: icons.list.horizontalList,
                url: 'role_master',
                auto_crud: true,
                breadcrumb: 'Role Master'
            },
            {
                name: 'menu.role',
                resource: 'role_master_per_account',
                icon: icons.list.horizontalList,
                url: 'role_master_per_account',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Role Master'
            },
            {
                name: 'menu.role',
                resource: 'reset_menus',
                icon: icons.list.horizontalList,
                url: 'reset_menus',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Role Master'
            },
            {
                name: 'menu.resource_master',
                resource: 'resource_master',
                icon: icons.list.horizontalList,
                url: 'resource_master',
                auto_crud: true,
                breadcrumb: 'Resource-Master'
            },
            {
                name: 'menu.permissions',
                resource: 'permissions_master',
                icon: icons.list.horizontalList,
                url: 'permissions_master',
                auto_crud: true,
                breadcrumb: 'Permissions'
            },
            {
                name: 'menu.manage_application',
                resource: 'application_master',
                icon: icons.list.horizontalList,
                url: 'application_master',
                auto_crud: true,
                breadcrumb: 'Application'
            },
            {
                name: 'menu.super_app_master',
                resource: 'super_app_master',
                icon: icons.list.horizontalList,
                url: 'super_app_master',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Super App Master'
            },
            {
                name: 'menu.lanuages_hidden',
                resource: 'account_languages_hidden',
                icon: icons.list.horizontalList,
                url: 'account_languages_hidden',
                showMenu: false,
                auto_crud: true,
                breadcrumb: 'Account Languages'
            },
            {
                name: 'menu.password_policy',
                check_permission: false,
                showMenu: false,
                resource: 'password_policy',
                icon: icons.list.horizontalList,
                url: 'password_policy',
                auto_crud: true
            },
            {
                name: 'menu.reset_user_password',
                check_permission: false,
                showMenu: false,
                resource: 'reset_user_password',
                icon: icons.list.horizontalList,
                url: 'reset_user_password',
                auto_crud: true
            },
            {
                name: 'menu.role_rbac',
                resource: 'role_rbac_per_account',
                icon: icons.list.horizontalList,
                url: 'role_rbac_per_account',
                showMenu: false,
                auto_crud: true,

            },
            {
                name: 'menu.role_rbac',
                resource: 'bi_role_rbac',
                icon: icons.list.horizontalList,
                url: 'bi_role_rbac',
                showMenu: false,
                auto_crud: true
            },
            {
                name: 'menu.ip_admission',
                resource: 'user_relationship_format',
                icon: 'fa fa-plus-square',
                url: 'user_relationship_format',
                auto_crud: true,
                breadcrumb: 'Admission',
                check_permission: false
            },
            {
                name: 'menu.user_relationship_mapping',
                resource: 'user_relationship_mapping',
                icon: icons.list.horizontalList,
                url: 'user_relationship_mapping',
                showMenu: false,
                auto_crud: true
            },
            {
                name: 'menu.user_relationship_mapping',
                resource: 'user_relationship_pending',
                icon: icons.list.horizontalList,
                url: 'user_relationship_pending',
                showMenu: false,
                auto_crud: true
            },
            {
                name: 'menu.user_relationship_mapping',
                resource: 'user_relationship_requests',
                icon: icons.list.horizontalList,
                url: 'user_relationship_requests',
                showMenu: false,
                auto_crud: true
            },
            {
                name: 'menu.user_relationship_mapping',
                resource: 'user_relationship_my_family',
                icon: icons.list.horizontalList,
                url: 'user_relationship_my_family',
                showMenu: false,
                auto_crud: true
            },
            {
                name: 'menu.user_relationship_mapping',
                resource: 'user_relationship_family_consents',
                icon: icons.list.horizontalList,
                url: 'user_relationship_family_consents',
                showMenu: false,
                auto_crud: true
            },
            {
                name: 'menu.permissions_systemLevel_bulkAdd',
                resource: 'permissions_systemLevel_bulkAdd',
                icon: icons.list.horizontalList,
                url: 'permissions_systemLevel_bulkAdd',
                auto_crud: true
            },
            {
                name: 'menu.role_data_scope',
                resource: 'role_data_scope',
                icon: icons.list.horizontalList,
                url: 'role_data_scope',
                showMenu: false,
                auto_crud: true
            },
            {
                name: 'menu.system_role_data_scope',
                resource: 'system_role_data_scope',
                icon: icons.list.horizontalList,
                url: 'system_role_data_scope',
                showMenu: false,
                auto_crud: true
            },
            {
                name: 'menu.system_rate_limit',
                resource: 'rate_limit',
                icon: icons.list.horizontalList,
                url: 'rate_limit',
                showMenu: false,
                auto_crud: true
            },
         

        ]
    },
  
    {
        name: 'menu.role_menu_master',
        icon: icons.application.role,
        data: {
            nav_url: "menu_m"
        },
        children: [
            {
                name: 'menu.menu_master',
                resource: 'menu_master',
                icon: icons.list.horizontalList,
                url: 'menu_master',
                auto_crud: true
            },
            {
                name: 'menu.profile_menu_master',
                resource: 'profile_menu_master',
                icon: icons.list.horizontalList,
                url: 'profile_menu_master',
                auto_crud: true
            },
            {
                name: 'menu.mobile_menu_master',
                resource: 'mobile_menu_master',
                icon: icons.list.horizontalList,
                url: 'mobile_menu_master',
                auto_crud: true
            },
            {
                name: 'menu.menu_master',
                resource: 'menu_master_per_account',
                icon: icons.list.horizontalList,
                url: 'menu_master_per_account',
                showMenu: false,
                auto_crud: true
            },
            {
                name: 'menu.menu_item_master',
                resource: 'menu_item_master',
                icon: icons.list.horizontalList,
                url: 'menu_item_master',
                auto_crud: true
            },
            {
                name: 'menu.menu_landingpage_mapping',
                resource: 'menu_landingpage_mapping',
                icon: icons.list.horizontalList,
                url: 'menu_landingpage_mapping',
                auto_crud: true
            },
            {
                name: 'menu.menu_landingpage_mapping',
                resource: 'menu_landingpage_mapping_per_account',
                icon: icons.list.horizontalList,
                url: 'menu_landingpage_mapping_per_account',
                showMenu: false,
                auto_crud: true
            },
            {
                name: 'menu.menu_landingpage_mapping',
                resource: 'reset_role_permissions',
                icon: icons.list.horizontalList,
                url: 'reset_role_permissions',
                showMenu: false,
                auto_crud: true
            }

        ]
    },
    {
        name: 'menu.growth_chart_master',
        icon: icons.application.role,
        check_permission: false,
        showMenu: false,
        resource: 'growth_chart_master',
        url: 'growth_chart_master',
        auto_crud: true
    },
    {
        name: 'menu.widget_master',
        icon: icons.application.role,
        check_permission: false,
        showMenu: false,
        resource: 'widget_master',
        url: 'widget_master',
        auto_crud: true
    },
    {
        name: 'ldap_config',
        resource: 'ldap_config',
        icon: icons.list.horizontalList,
        url: 'ldap_config',
        showMenu: false,
        auto_crud: true
    },
    {
        name: 'training_videos_master',
        resource: 'training_videos_master',
        icon: icons.list.horizontalList,
        url: 'training_videos_master',
        showMenu: true,
        auto_crud: true
    },
    {
        "name": "user_manual_document",
        resource: 'user_manual_document',
        icon: icons.list.horizontalList,
        url: 'user_manual_document',
        showMenu: true,
        auto_crud: true
    },
    {
        "name": "key_value_master",
        resource: 'key_value_master',
        icon: icons.list.horizontalList,
        url: 'key_value_master',
        showMenu: true,
        auto_crud: true
    },
    {
        "name": "patient_user_manual_document",
        resource: 'patient_user_manual_document',
        icon: icons.list.horizontalList,
        url: 'patient_user_manual_document',
        showMenu: true,
        auto_crud: true
    },
    {
        "name": "request_account",
        resource: 'request_account',
        icon: icons.list.horizontalList,
        url: 'request_account',
        showMenu: true,
        auto_crud: true
    },
    {
        name: 'training_videos_workflow',
        resource: 'training_videos_workflow',
        icon: icons.list.horizontalList,
        url: 'training_videos_workflow',
        showMenu: false,
        auto_crud: true
    },
    {
        name: 'training_videos_modules',
        resource: 'training_videos_modules',
        icon: icons.list.horizontalList,
        url: 'training_videos_modules',
        showMenu: true,
        auto_crud: true
    },
    {
        name: 'menu.test_resource',
        resource: 'test_resource',
        icon: icons.list.horizontalList,
        url: 'test_resource',
        auto_crud: true,
        breadcrumb: 'Manage Account Admins'
    },
    {
        name: 'Dashboard Template Master',
        resource: 'dynamic_template_master',
        icon: icons.list.horizontalList,
        url: 'dynamic_template_master',
        auto_crud: true,
        breadcrumb: 'dynamic_template_master'
    },
    {
        name: 'Form Template Mapping',
        resource: 'form_template_mapping',
        icon: icons.list.horizontalList,
        url: 'form_template_mapping',
        auto_crud: true,
        breadcrumb: 'form_template_mapping'
    },
    {
        name: 'menu.role',
        resource: 'userRole_mapping',
        icon: icons.list.horizontalList,
        url: 'userRole_mapping',
        auto_crud: true,
        breadcrumb: 'Role Master',
        showMenu: false
    },
    {
        name: 'menu.user_ai_agent_mapping',
        resource: 'user_ai_agent_mapping',
        icon: icons.list.horizontalList,
        url: 'user_ai_agent_mapping',
        auto_crud: true,
        breadcrumb: 'User AI Agent Mapping',
        showMenu: false
    },
    {
        name: 'menu.manage_account_users',
        resource: 'manage_account_users',
        icon: icons.list.horizontalList,
        url: 'manage_account_users',
        auto_crud: true,
        breadcrumb: 'Role Master',
        showMenu: false
    },
    {
        name: 'menu.userRole_mapping_view',
        resource: 'userRole_mapping_view',
        icon: icons.list.horizontalList,
        url: 'userRole_mapping_view',
        auto_crud: true
    },
    {
        name: 'menu.role',
        resource: 'role_per_facility_view',
        icon: icons.list.horizontalList,
        url: 'role_per_facility_view',
        auto_crud: true,
        breadcrumb: 'role_per_facility_view',
        showMenu: false
    },
    {
        name: 'menu.role',
        resource: 'menu_per_facility_view',
        icon: icons.list.horizontalList,
        url: 'menu_per_facility_view',
        auto_crud: true,
        breadcrumb: 'menu_per_facility_view',
        showMenu: false
    },
    {
        name: 'menu.resource_share',
        resource: 'resource_share',
        icon: icons.list.horizontalList,
        url: 'resource_share',
        auto_crud: true,
        breadcrumb: 'resource_share',
        showMenu: false
    },
    {
        name: 'menu.suspend_feature',
        icon: icons.list.horizontalList,
        resource: 'suspend_feature',
        url: 'suspend_feature',
        auto_crud: true,
        showMenu: false
    },
    {
        name: 'menu.eula_report_template_mapping',
        icon: icons.list.horizontalList,
        resource: 'eula_report_template_mapping',
        url: 'eula_report_template_mapping',
        auto_crud: true,
        showMenu: false
    },
    {
        name: 'menu.role_auth',
        icon: icons.list.horizontalList,
        resource: 'role_auth',
        url: 'role_auth',
        auto_crud: true
    },
    {
        name: 'menu.device_auth_request',
        icon: icons.list.horizontalList,
        resource: 'device_auth_request',
        url: 'device_auth_request',
        auto_crud: true
    },
    {
        name: 'menu.training_videos',
        icon: 'fa fa-tag',
        resource: 'training_videos',
        url: 'training_videos',
        auto_crud: true
    },
    {
        name: 'menu.video_marking',
        icon: 'fa fa-tag',
        resource: 'video_marking',
        url: 'video_marking',
        auto_crud: true
    },
    {
        name: 'pagename.list.app_config',
        icon: 'fa fa-tag',
        resource: 'app_config',
        url: 'app_config',
        auto_crud: true
    },
    {
        "resource": "widget_config",
        "url": "widget_config",
        "auto_crud": true
    },
    {
        "resource": "widget_master",
        "url": "widget_master",
        "auto_crud": true
    },
    {
        "resource": "dashboard_master_list",
        "url": "dashboard_master_list",
        "auto_crud": true
    },
    {
        "resource": "build_app_request",
        "url": "build_app_request",
        "auto_crud": true
    },
    {
        "resource": "user_group",
        "url": "user_group",
        "auto_crud": true
    },
    // {
    //     "resource": "help_doc",
    //     "url": "help_doc",
    //     "auto_crud": true
    // },
    {
        "resource": "audit_log",
        "url": "audit-log",
        "auto_crud": true
    },
    {
        "resource": "notice",
        "url": "notice",
        "auto_crud": true
    },
    {
        "resource": "route_item_mapping",
        "url": "route_item_mapping",
        "auto_crud": true
    },
    {
        resource: "account_license",
        url: "account_license",
        auto_crud: true
    },
    {
        resource: "resource_properties",
        url: "resource_properties",
        auto_crud: true
    },
    {
        resource: "region_master",
        url: "region_master",
        auto_crud: true
    },
    {
        resource: 'user_region_mapping',
        url: 'user_region_mapping',
        auto_crud: true
    },
    {
        resource: 'auth_restriction',
        url: 'auth_restriction',
        auto_crud: true
    },
    {
        name: "menu.country_telecom_code_mapping",
        resource: "country_telecom_code_mapping",
        url: "country_telecom_code_mapping",
        auto_crud: true,
        breadcrumb: "Country And Telecom Code Mapping"
    },
    {
        resource: 'dms_logs',
        url: 'dms_logs',
        auto_crud: true
    },
    {
        resource: 'drug_class_master',
        url: 'drug_class_master',
        auto_crud: true
    },
    {
        resource: 'drug_sub_class_master',
        url: 'drug_sub_class_master',
        auto_crud: true
    },
    {
        resource: 'ai_audit_logs',
        url: 'ai_audit_logs',
        auto_crud: true
    },
    {
        name: 'menu.inter_account_master',
        icon: icons.application.role,
        check_permission: false,
        showMenu: false,
        resource: 'inter_account_master',
        url: 'inter_account_master',
        auto_crud: true
    },

]
